export const ProcedureData = [
  {
    id: 1,
    title: 'SELECT TRACTOR',
    image: 'https://res.cloudinary.com/nayo/image/upload/v1668486326/icon1_f3qju5.png',
    desc: 'is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the',
  },
  {
    id: 2,
    title: 'CALCULATE THE COST',
    image: 'https://res.cloudinary.com/nayo/image/upload/v1668487230/icon2_l4sogm.png',
    desc: 'is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the',
  },
  {
    id: 3,
    title: 'RENT TRACTOR',
    image: 'https://res.cloudinary.com/nayo/image/upload/v1668487229/icon3_sewhme.png',
    desc: 'is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the',
  },
];

export const HeroDesc = 'is simply dummy text of the printing and typesetting industry. LoremIpsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.';
